import React, { Component } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import {
  MenuItem,
  CircularProgress,
  Button,
} from "@material-ui/core";
import { FiSearch } from "react-icons/fi";
import { postItem } from "./redux/PrsSearchButtonActions";
import HelpWrap from "modules/ml-admin/help-admin/help-view/HelpWrap";


class PrsSearchButton extends Component {

  constructor(props) {
    super();
    this.state = {}

  }

  componentDidMount() { }

  searchInPrs = () => {
    const {
      trackID,
      postItem,
      handleClose,
      prsSearchRefreshDataType,
      callBack
    } = this.props;

    postItem(trackID, handleClose, prsSearchRefreshDataType, callBack ? callBack : null);
  }

  render() {
    const {
      classes,
      id,
      data: {
        posting: { busy },
      },
      helpComponentModule,
      isButton,
      isDisabled
    } = this.props;


    return (
      <Translation>
        {(t, { i18n }) => (
          <>
            {isButton ? <>
              <Button size="small" title={"Match with PRS"} className={"globalCreateSaveButton"} disabled={busy || isDisabled || false}
                onClick={(e) => {
                  e.stopPropagation();
                  this.searchInPrs();
                }}> PRS Auto Match  {busy && <CircularProgress style={{ marginLeft: "10px" }} size={20} className={classes.preLoader} />}</Button>
            </> :
              <MenuItem
              id={`context-match-prs-${id}`}
               
                disabled={busy || isDisabled || false}
                onClick={(e) => {
                  e.stopPropagation();
                  this.searchInPrs();
                }}>
                <FiSearch className={classes.contextIcons} />
                Match with PRS  {busy && <CircularProgress style={{ marginLeft: "10px" }} size={20} className={classes.preLoader} />}
                {helpComponentModule && <HelpWrap config={helpComponentModule} />}
              </MenuItem>
            }

          </>
        )}
      </Translation>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.searchPrs,
});

export default connect(mapStateToProps, {
  postItem
})(PrsSearchButton);
